export default "__VITE_ASSET__5bIS4vOD__"